import { combineReducers } from 'redux';
import { reducer as reduxForm } from 'redux-form';

import accountsReducer from './accountsReducer';
import accountReportReducer from './accountReportReducer';
import agentReportReducer from './agentReportReducer';
import csrAgentsReducer from './csrAgentsReducer';
import switchTypeReducer from './switchTypeReducer';
import targetAccountReducer from './targetAccountReducer';
import targetAgentReducer from './targetAgentReducer';
import tokenReducer from './tokenReducer';

export default combineReducers({
  form: reduxForm,
  access: tokenReducer,
  agent: csrAgentsReducer,
  account: accountsReducer,
  switchType: switchTypeReducer,
  targetAccount: targetAccountReducer,
  targetAccountReport: accountReportReducer,
  targetAgent: targetAgentReducer,
  targetAgentReport: agentReportReducer,
});
